export default {
  yandexdirect: 'yd',
  googleads: 'gads',
  vk: 'vk',
  vkads: 'vk-ads',
}
